import React, { FormHTMLAttributes, forwardRef } from "react";

export interface FormProps extends FormHTMLAttributes<HTMLFormElement> {
  /**
   * When true (default), blocks the browser's native form submit / page reload.
   * Set false only for full-page auth flows that rely on native submit behavior.
   */
  preventReload?: boolean;
}

/**
 * App form shell: prevents accidental page reloads from Enter key or stray submit buttons.
 * Pair with `<Button type="submit">` for save actions, or keep `onClick` handlers on buttons.
 */
export const Form = forwardRef<HTMLFormElement, FormProps>(
  ({ onSubmit, preventReload = true, noValidate, ...props }, ref) => (
    <form
      ref={ref}
      noValidate={noValidate ?? true}
      {...props}
      onSubmit={(event) => {
        if (preventReload) {
          event.preventDefault();
        }
        onSubmit?.(event);
      }}
    />
  )
);

Form.displayName = "Form";
